import { Text, Image, Box, Flex } from "@chakra-ui/react";

export default function ComplianceBanner() {
  return (
    <Flex justifyContent={"center"} p="10" gap={{ base: "6", sm: "12" }}>
      <Flex justifyContent={"center"} alignItems="center" flexDir="column" textAlign={"center"}>
        <Image src="/images/gdpr.png" alt="Landing" mx={2} width={{ base: "70px" }} />
        <Text fontSize="xs" mt="10px">
          Made in the European Union
        </Text>
      </Flex>

      <Flex justifyContent={"center"} alignItems="center" flexDir="column" textAlign={"center"}>
        <Image
          src="/images/azure-logo.png"
          alt="Landing"
          mx={2}
          my="7px"
          height={{ base: "56px" }}
        />
        <Text fontSize="xs" mt="10px">
          Enterprise Security & Reliability
        </Text>
      </Flex>
    </Flex>
  );
}
